// @flow
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {trigger as edapTrigger} from '../../utils/edapWrapper';
import {canonicalizeSearchRequest} from '../../utils/searchParamsUtils';
import {toURL} from '@homeaway/search-url-parser';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {Link} from '@homeaway/react-localization-components';

import type {State as ReduxState} from '../../reducers';
import type {TripQuery} from '../../utils/tripData';

import './FallbackComponent.less';

type Props = {
    siteName: string,
    timeout?: boolean
} & TripQuery;

// TODO: replace with the 404 page from SERP-343
export class FallbackComponent extends Component<Props> {
    componentDidMount() {
        this.didHaveError();
    }

    buildRedirectUrl = () => {
        const {
            adultsCount,
            arrival,
            childrenCount,
            departure,
            petIncluded
        } = this.props;

        const searchRequest = canonicalizeSearchRequest({
            adultsCount,
            arrival,
            childrenCount,
            departure,
            petIncluded
        });

        return toURL(searchRequest);
    };

    didHaveError = () => {
        edapTrigger('generic.error', {
            logmessage: 'oops',
            highfrequency: 'true'
        });
    };

    render() {
        const href = this.buildRedirectUrl();
        return (
            <div className="FallbackComponent" data-wdio="FallbackComponent">
                <FormattedMessage
                    tagName="h3"
                    id={
                        this.props.timeout
                            ? 'oopsTimeoutMessage'
                            : 'tempOopsMessage'
                    }
                />
                <div data-wdio="FallbackComponent_link">
                    <Link href={href}>
                        {(localizedUrl) => (
                            <ButtonPrimary
                                id={'tempsOopsRedirect'}
                                href={localizedUrl}
                                label={
                                    <FormattedMessage id="tempOopsRedirect" />
                                }
                            />
                        )}
                    </Link>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({
    system: {siteName},
    searchParams: {
        params: {adultsCount, arrival, childrenCount, departure, petIncluded}
    }
}: ReduxState): Props => ({
    siteName,
    adultsCount,
    arrival,
    childrenCount,
    departure,
    petIncluded
});

export default compose(connect(mapStateToProps))(FallbackComponent);
